import { render } from "./Add_Repo.vue?vue&type=template&id=43b9b4e2&scoped=true&ts=true"
import script from "./Add_Repo.vue?vue&type=script&lang=ts"
export * from "./Add_Repo.vue?vue&type=script&lang=ts"

import "./Add_Repo.vue?vue&type=style&index=0&id=43b9b4e2&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b9b4e2"]])

export default __exports__